/**
 * Exercice « sur la feuille » : rendu PAR DÉFAUT pour tout le monde depuis le
 * 28/10/2026 (avec ou sans compte). Seul le forçage de l'appareil
 * (`?paper=0` / `?paper=1` dans l'URL, mémorisé dans localStorage
 * `jr_paper_player`) peut remettre l'ancien affichage. Le drapeau en base
 * `paper_player` (migration 0689) n'est plus lu : attendre sa réponse faisait
 * clignoter l'ancien rendu au chargement.
 */

import { useState } from 'react';

export const PAPER_PLAYER_STORAGE_KEY = 'jr_paper_player';

/** Rendu quand l'appareil n'a rien forcé. */
export const PAPER_PLAYER_DEFAULT = true;

/** Mode feuille, forçage compris. Pure. */
export function paperEnabled(override: boolean | null): boolean {
  return override ?? PAPER_PLAYER_DEFAULT;
}

/** Lit (et mémorise) le forçage de l'appareil. `null` = pas de forçage. */
export function readPaperOverride(search: string, storage: Storage | null): boolean | null {
  const param = new URLSearchParams(search).get('paper');
  if (param === '1' || param === '0') {
    try {
      storage?.setItem(PAPER_PLAYER_STORAGE_KEY, param);
    } catch {
      /* stockage indisponible : le forçage vaut pour cette page seulement */
    }
    return param === '1';
  }
  try {
    const v = storage?.getItem(PAPER_PLAYER_STORAGE_KEY);
    if (v === '1' || v === '0') return v === '1';
  } catch {
    /* navigation privée */
  }
  return null;
}

function safeStorage(): Storage | null {
  try {
    return typeof window === 'undefined' ? null : window.localStorage;
  } catch {
    return null;
  }
}

/** Forçage de l'appareil seul (`null` = rien de forcé). */
export function usePaperOverride(): boolean | null {
  const [override] = useState(() =>
    typeof window === 'undefined' ? null : readPaperOverride(window.location.search, safeStorage()),
  );
  return override;
}

export function usePaperPlayer(
  // gardé pour les appelants : le rendu ne dépend plus du compte
  _user?: { id?: string | null; role?: string | null } | null,
): boolean {
  return paperEnabled(usePaperOverride());
}

/** Mode feuille de l'appareil (tous les écrans à questions). */
export function usePaperPlayerForMe(): boolean {
  return paperEnabled(usePaperOverride());
}
